module.exports = __webpack_public_path__ + "static/media/nidalee-win.71651d67.png";